import { Vue, Component } from 'vue-property-decorator';
import { IPAGE } from '@/types/base.d';

@Component
export default class PageMixin extends Vue {
  public page: IPAGE = {
    pageNo: 1,
    pageSize: 20,
  }

  public total: number = 0

  public pageSizes: Array<number> = [20, 30, 50]

  // 分页 page change 事件
  public pageChange(value: number) {
    this.page.pageNo = value;
  }

  // 分页 size change 事件
  public sizeChange(value: number) {
    this.page.pageSize = value;
    this.page.pageNo = 1;
  }
}
